module.exports = __webpack_public_path__ + "img/quickresume_logo.8fad7b22.png";